module.exports = __webpack_public_path__ + "static/media/ebilling-logotype-l.e7a5642e.svg";